import './ChatHeader.css';

interface Props {
  agentName: string;
  agentTitle: string;
  statusLabel: string;
  isActive?: boolean;
}

export const ChatHeader = ({agentName, agentTitle, statusLabel, isActive = true}: Props) => (
  <div className="chat-header">
    <h2 className="chat-header__name">
      {agentName} – {agentTitle}
    </h2>
    <div className="chat-header__status">
      <span className={`chat-header__status-dot${isActive ? ' chat-header__status-dot--active' : ''}`} />
      <span className="chat-header__status-label">{statusLabel}</span>
    </div>
  </div>
);
